<template>
  <div class="coupon-index">
    <div class="coupon-header">
      <span>{{ $t("Coupon.helpText") }}</span>
    </div>

    <template v-if="coupons.length == 0">
      <div class="coupon-nocoupon">
        <FacePhraseForIndexPage phrase="クーポンはありません​" />
      </div>
    </template>
    <template v-else>
      <div class="coupon-container" :class="isPastCoupon && 'past'">
        <div class="coupon-division" v-for="coupon in coupons" :key="coupon.id">
          <ItemIndexCoupons :isPastCoupon="isPastCoupon" :coupon="coupon" />
        </div>
      </div>
    </template>

    <div class="coupon-footer" v-if="!isPastCoupon" @click="goToPastCoupons()">
      <div>{{ $t("Coupon.pastCoupon") }}</div>

      <div class="item-btn">
        <img :src="require('@/assets/img/icon/svg/arrow-right.svg')" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";

import { useStore } from "vuex";
import { useRoute } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TheCouponsIndex",
  setup(props) {
    const route = useRoute();
    const store = useStore();
    const coupons = computed(() => store.getters["coupon/externalCoupons"]);

    const isPastCoupon = computed(() => route.path.includes("past-coupons"));

    const goToPastCoupons = () => {
      if (process.env.NODE_ENV == "local") {
        return (window.location.href = `/#/past-coupons/index`);
      }

      nativeHandlerService.openPastCoupons(
        `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}past-coupons/index`
      );
    };

    return {
      coupons,
      isPastCoupon,
      goToPastCoupons,
    };
  },
};
</script>

<style scoped lang="scss">
.coupon-header {
  font-weight: 500;
  font-size: 12px;
  text-align: justify;
  padding: 20px 15px;
  color: #828282;
}
.coupon-index {
  background: white;
  height: calc(100vh - 20px);
  overflow: hidden;
}

.coupon-container {
  height: calc(100vh - 165px);
  overflow: auto;
}

.coupon-container.past {
  height: calc(100vh - 80px);
}

.coupon-nocoupon {
  height: calc(100vh - 165px);
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  .non-message {
    padding-top: unset;
  }
}

.coupon-division {
  background: white;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px 0px;

  &:first-child {
    border-top: 1px solid #e0e0e0;
  }
}

.coupon-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px;
  padding: 0 15px;
  border-radius: 9px;
  border: 1px solid #e8e8e8;
  background: white;
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  line-height: 21px;
}
</style>
